'use es6';

import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as Data from 'ecosystem-marketplace-core/constants/dataSyncs/Data';
import * as Sync from 'ecosystem-marketplace-core/constants/dataSyncs/Sync';
import * as SuperCategory from 'ecosystem-marketplace-core/constants/groupTags/SuperCategory';
import * as HubSpotFeature from 'ecosystem-marketplace-core/constants/groupTags/HubSpotFeature';
import { BY_CATEGORY as FEATURES_BY_CATEGORY } from 'ecosystem-marketplace-core/constants/groupTags/categoryFeatures';
import categoryPropType from 'ecosystem-marketplace-core/constants/propTypes/category';
import createObjectValuesPropType from 'ecosystem-marketplace-core/constants/propTypes/createObjectValuesPropType';
import planTypePropType from 'ecosystem-marketplace-core/constants/propTypes/planType';
import Pricing from 'marketplace-ui-common/records/Pricing';
import AppInstallability from 'ecosystem-marketplace-core/records/AppInstallability';
import StorefrontFilters from '../records/StorefrontFilters';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import * as ConnectionType from './ConnectionType';
import Review from 'marketplace-ui-reviews/records/Review';
import ReviewsStats from 'marketplace-ui-reviews/records/ReviewStats';
export const category = categoryPropType;
export const superCategory = createObjectValuesPropType(SuperCategory);
export const dataSyncDirection = createObjectValuesPropType(Sync);
export const categoryFeature = PropTypes.oneOf(Object.values(FEATURES_BY_CATEGORY).reduce((acc, current) => acc.concat(Object.values(current)), []));
export const hubspotFeature = createObjectValuesPropType(HubSpotFeature);
export const pricingPlanType = planTypePropType;
export const pricingPlan = PropTypes.instanceOf(Pricing);
export const dataSync = ImmutablePropTypes.recordOf({
  data: PropTypes.oneOf(Object.values(Data)).isRequired,
  description: PropTypes.string,
  sync: dataSyncDirection.isRequired,
  target: PropTypes.string.isRequired
});
export const storefrontFilters = PropTypes.instanceOf(StorefrontFilters);
export const requestState = createObjectValuesPropType(RequestState);
export const connectionType = createObjectValuesPropType(ConnectionType);
export const reviews = ImmutablePropTypes.listOf(PropTypes.instanceOf(Review));
export const reviewStats = PropTypes.instanceOf(ReviewsStats);
export const installability = PropTypes.instanceOf(AppInstallability);